/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_ConvertInputs */

const en_btn_convert = /** @type {(inputs: Btn_ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert`)
};

const ko_btn_convert = /** @type {(inputs: Btn_ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변환`)
};

const ja_btn_convert = /** @type {(inputs: Btn_ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変換`)
};

/**
* | output |
* | --- |
* | "Convert" |
*
* @param {Btn_ConvertInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const btn_convert = /** @type {((inputs?: Btn_ConvertInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_ConvertInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_convert(inputs)
	if (locale === "ko") return ko_btn_convert(inputs)
	return ja_btn_convert(inputs)
});